export interface Timezone {
    value: string;
    label: string;
}

function parseOffsetMinutes(label: string): number {
    const match = label.match(/GMT([+-])(\d{2}):(\d{2})/);
    if (!match) return 0;
    const sign = match[1] === '+' ? 1 : -1;
    return sign * (parseInt(match[2]) * 60 + parseInt(match[3]));
}

export function getTimezones(): Timezone[] {
    const now = new Date();
    return Intl.supportedValuesOf('timeZone')
        .map((tz) => {
            try {
                const parts = new Intl.DateTimeFormat('en', {
                    timeZone: tz,
                    timeZoneName: 'longOffset',
                }).formatToParts(now);
                const offset = parts.find((p) => p.type === 'timeZoneName')?.value ?? 'GMT+00:00';
                const name = tz.replace(/_/g, ' ');
                return { value: tz, label: `(${offset}) ${name}` };
            } catch {
                return { value: tz, label: tz };
            }
        })
        .sort((a, b) => {
            const diff = parseOffsetMinutes(a.label) - parseOffsetMinutes(b.label);
            return diff !== 0 ? diff : a.value.localeCompare(b.value);
        });
}
